import React from "react";
import { string } from "prop-types";
import styled from "styled-components";

const Container = styled.ul`
  list-style: none;
  margin-bottom: 2rem;
`;

const ListItem = styled.li`
  font-size: 1.1rem;
  margin-bottom: 0.4rem;
`;

const UppercaseContent = styled.span`
  text-transform: uppercase;
`;

const Address = ({ address1, address2, city, country, zipcode }) => (
  <Container>
    <ListItem data-id="address1">{address1}</ListItem>
    {address2 && <ListItem data-id="address2">{address2}</ListItem>}
    <ListItem data-id="zipcode-city">
      {zipcode} {city}
    </ListItem>
    <ListItem data-id="country">
      <UppercaseContent>{country}</UppercaseContent>
    </ListItem>
  </Container>
);

Address.propTypes = {
  address1: string.isRequired,
  address2: string,
  city: string.isRequired,
  country: string.isRequired,
  zipcode: string.isRequired,
};

export default Address;
